import React from 'react';

class ContactPage extends React.Component {
  render() {
    let contents = '';
    
    if (this.props.language === "EN") {
      contents = <p>Have a question? Want to request ordering information?</p>
    } else {
      contents = <p>Preguntas y Pedidos:</p>
    }
    
    return (
      <div className="ContactPage">
        {contents}
        <p className="phone">+1 (201) 214-6372</p>
        <p>LinkedIn: <a target="_blank" href="https://www.linkedin.com/in/sonia-andreola-00539479/">Sonia Andreola</a></p>
      </div>
    )
  }
}

export default ContactPage;


// WEBPACK FOOTER //
// ./src/ContactPage.js